import React from 'react';
import { ReactComponent as PlusCircle } from 'Icons/PlusCircle.svg';
import ELayersView from 'enums/ELayersView';
import { usePreserveExperiment } from 'redux/hooks';
import RMButton from 'components/customComponents/Controls/RMButton';
import { FragmentLayerDTO } from 'business/models/Models';
import { ReactComponent as Edit } from 'Icons/CommandPanel/Edit.svg';
import { ReactComponent as Delete } from 'Icons/CommandPanel/Delete.svg';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { treeNodeIconsColor } from 'utils/Global';
import {
  useIsEditMode,
  useModifyAccessRights,
  useSelectedExpLayer,
  useSetSelectedLayerDetail,
} from './hooks';
import { FmlxButton } from 'fmlx-common-ui';
import { useAllowLayerEditing } from 'redux/hooks/experiment';

export type FragmentLayerContentProps = {
  setContentView: any;
};

export const FragmentLayerContent = (props: FragmentLayerContentProps) => {
  const { setContentView } = props;
  const callPreserveUndoableState = usePreserveExperiment();
  const isEditMode: boolean = useIsEditMode();
  const modifyAccessRights: boolean = useModifyAccessRights();
  const _selectedLayer = useSelectedExpLayer();
  const _setSelectedLayerDetail = useSetSelectedLayerDetail();
  const isLayerEditingAllowed = useAllowLayerEditing();

  const fragmentLayerDetails = _selectedLayer.layerDetail as FragmentLayerDTO;

  const addFragment = () => {
    setContentView(ELayersView.SELECTFRAGMENTSCREEN);
  };

  const onEditFragment = () => {
    setContentView(ELayersView.EDITFRAGMENT);
  };

  const onDeleteFragment = () => {
    callPreserveUndoableState();
    const updatedSelectedLayerDetails = new FragmentLayerDTO();
    updatedSelectedLayerDetails.experimentId = fragmentLayerDetails.experimentId;
    updatedSelectedLayerDetails.layerId = fragmentLayerDetails.layerId;
    updatedSelectedLayerDetails.id = fragmentLayerDetails.id;
    updatedSelectedLayerDetails.fragmentScreenId = 0;
    updatedSelectedLayerDetails.startingWellNumber = null;
    _setSelectedLayerDetail(updatedSelectedLayerDetails);
  };

  const getFragmentCardView = () => {
    if (!_selectedLayer || !fragmentLayerDetails?.fragmentScreen) {
      return null;
    }

    const fragmnentName = fragmentLayerDetails.fragmentScreen.treeNode.name;
    const conditions = fragmentLayerDetails.fragmentScreen.fragmentFragmentScreen.length;
    const dropNumber = _selectedLayer.targetDrop;
    const fragmentVolume = fragmentLayerDetails.volume;
    return (
      <FragmentCard
        conditions={conditions}
        layer={_selectedLayer}
        fragmentScreenName={fragmnentName}
        isEditMode={isEditMode && modifyAccessRights}
        customStyle={{
          marginTop: '5px',
          border: 'none',
          borderTop: '1px solid #BFBFBF',
          borderRadius: '0px',
        }}
        onEditFragment={onEditFragment}
        onDeleteFragment={onDeleteFragment}
        isLayerEditingAllowed={isLayerEditingAllowed}
        dropNumber={dropNumber}
        fragmentVolume={fragmentVolume}
      />
    );
  };
  return (
    <>
      {(!fragmentLayerDetails || !fragmentLayerDetails.fragmentScreen) &&
        isEditMode &&
        modifyAccessRights && (
          <RMButton
            id="commandpanel-fragmentlayercontent-add-button"
            Icon={
              <PlusCircle
                style={{ height: '1.5rem', width: '1.5rem', marginRight: '0.44rem' }}
              />
            }
            customStyle={{
              width: '14.81rem',
              height: '3rem',
              maxHeight: '3rem',
              minHeight: '3rem',
              borderRadius: '0.5rem',
              fontSize: '1.25rem',
              lineHeight: '1.45rem',
            }}
            onClick={addFragment}
            label={'Add Fragment'}
            type={FmlxButton.Type.POSITIVE}
            withIcon={FmlxButton.WithIcon.START}
          ></RMButton>
        )}
      <div
        id="commandpanel-fragmentlayercontent-cardview"
        style={{ overflowY: 'auto', overflowX: 'hidden', height: '45vh', width: '100%' }}
      >
        {getFragmentCardView()}
      </div>
    </>
  );
};

export const FragmentCard = ({
  conditions,
  layer,
  fragmentScreenName,
  isEditMode,
  customStyle,
  onEditFragment,
  onDeleteFragment,
  isLayerEditingAllowed,
  dropNumber,
  fragmentVolume,
}) => {
  return (
    <div
      id="commandpanel-fragmentcard-wrapper"
      className={'ingredient-card'}
      style={customStyle}
    >
      <div
        id="commandpanel-fragmentcard-icon-wrapper"
        className="flex ing-icons  flex-space-between flex-y-center"
      >
        <RMSvgIcon
          id="commandpanel-fragmentcard-screen-icon"
          name="FragmentScreen"
          fill={treeNodeIconsColor}
        />
      </div>
      <div id="commandpanel-fragmentcard-content-wrapper" className="flex flex-column ing-content">
        <div id={`commandpanel-fragmentcard-name-${fragmentScreenName}`} className="ingredient-card-text">
          {fragmentScreenName}
        </div>
        <div id="commandpanel-fragmentcard-conditions" className="ingredient-card-text ing-card-light">
          {`${conditions} conditions`}
        </div>
        <div id="commandpanel-fragmentcard-usedcount" className="ingredient-card-text ing-card-light">
          {`${
            (layer.height + 1) * (layer.width + 1)
          } used, Drop ${dropNumber}, Fragment Vol ${fragmentVolume} μL`}
        </div>
      </div>
      {isEditMode && isLayerEditingAllowed && (
        <div
          id="commandpanel-fragmentcard-actions-wrapper"
          className="flex ing-delete-update flex-space-around [&_path]:fill-black"
        >
          <Edit
            id="commandpanel-fragmentcard-editbtn"
            onClick={onEditFragment}
            className="cursor-pointer hover:opacity-70"
          />
          <Delete
            id="commandpanel-fragmentcard-deletebtn"
            onClick={onDeleteFragment}
            className="cursor-pointer hover:opacity-70"
          />
        </div>
      )}
    </div>
  );
};
